import React from "react";
import { Route, Routes } from "react-router-dom";
import AboutUs from "../pages/AboutUs";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndCondition from "../pages/TermsAndCondition";
import Home from "../pages/Home";
import CourseDetails from "../pages/CourseDetails";
import BecomePartner from "../pages/BecomePartner";
import SuccessStoriesPage from "../pages/SuccessStories/SuccessStories";
import ExploreOurCourses from "../pages/ExploreOurCourses";
import Blogs from '../pages/Blogs';
import BlogSearch from '../pages/BlogSearch';
import BlogPost from "../pages/BlogPost";
import RiseupEvent from "../pages/RiseupEvent";

const AllRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
      <Route path="/program/:id" element={<CourseDetails />} />
      <Route path="/becomePartner" element={<BecomePartner />} />
      <Route path="/successStories" element={<SuccessStoriesPage />} />
      <Route path="/ExploreOurCourses" element={<ExploreOurCourses />} />
      <Route path='/blogs' element={<Blogs />} />
      <Route path='/blogSearch' element={<BlogSearch />} />
      <Route path='/blogs/:id' element={<BlogPost />} />
      <Route path='/events' element={<RiseupEvent />} />
    </Routes>
  )
}

export default AllRoute

